// Pinned to last working version due to OpenFreeMap deployment outage
// (github.com/hyperknot/openfreemap/issues/112). Set to null to use
// dynamic /planet TileJSON discovery once the outage is resolved.
const OFM_PINNED_VERSION: string | null = '20260513_001001_pt'

export const OFM_TILEJSON_URL = 'https://tiles.openfreemap.org/planet'

export const OFM_PINNED_TILE_URL = OFM_PINNED_VERSION
  ? `https://tiles.openfreemap.org/planet/${OFM_PINNED_VERSION}/{z}/{x}/{y}.pbf`
  : null

export const OFM_MAXZOOM = 14
export const OFM_MINZOOM = 0
